import { LIMITS, freshSeed, type RunRequest, type RunResult } from './scriptRunner.ts';

/**
 * Runs a script in a fresh sandbox Worker (sandbox.worker.ts), and ends that Worker from here
 * if it hasn't answered a little after the script's own deadline - however the script got
 * stuck. Nothing a script does reaches the page except the plain result it posts back.
 */
export function runScript(source: string, seed: string | null = null): Promise<RunResult> {
  const request: RunRequest = { source, seed: seed ?? freshSeed() };
  return new Promise((resolve) => {
    const worker = new Worker(new URL('./sandbox.worker.ts', import.meta.url), { type: 'module', name: 'script-sandbox' });
    const end = (result: RunResult) => {
      window.clearTimeout(timer);
      worker.terminate();
      resolve(result);
    };
    const failed = (error: string): RunResult => ({ ok: false, seed: request.seed!, log: '', entries: [], generated: null, error });
    // Loading QuickJS the first time takes a moment, so the page allows more than the script's own limit.
    const timer = window.setTimeout(() => end(failed(`The script ran for more than ${LIMITS.millis / 1000} seconds, so it was stopped.`)), LIMITS.millis + 5_000);
    worker.onmessage = (event: MessageEvent<RunResult>) => end(event.data);
    worker.onerror = () => end(failed('The script sandbox could not start. Reload the page and try again.'));
    worker.postMessage(request);
  });
}
